/**
 * This controller handles the pagination automatically.
 * It is meant to be be extended by the component's controller that need the pagination.
 *
 */
export default class PaginatedController {

    /**
     * @param model is the model from BBModel. i.e BBModel.Events
     * @param loaderContainer
     */
    constructor(model) {
        this.model = model;
        this.page = 1;
        this.filterParams = {};
        this.sortParams = {};
        this.options = {};
    }

    /**
     * This method is called by the pagination component and calls
     * the APIs with the current page
     */
    changePage() {
        this.onPageChangeStarted();

        const options = {
            per_page: 10,
            page: this.page,
            /*
             * $JsonProc is used to build an url with params as arrays.
             * i.e. if you need to add filters, the APIs accept ?filter_by[date]=2017-03-04
             * and the old implementation tried to serialise an object like ?filter_by=date,2017-03-04
             *
             * Check angular-hal.js at hrefLink() function for more details
             */
            $JsonProc: true
        };


        Object.assign(options, this.options);

        // We need to clean this Object and get rid of any null or undefined values
        Object.keys(this.filterParams).forEach((key) => {

            // contextually let's check for dates and format them into API accepted format
            if (this.filterParams[key] instanceof Date) {
                if (moment(this.filterParams[key], 'YYYY-MM-DD', true).isValid()) {
                    this.filterParams[key] = moment(this.filterParams[key]).format('YYYY-MM-DD');
                } else {
                    delete this.filterParams[key];
                }
            }

            return (this.filterParams[key] === null || this.filterParams[key] === undefined || this.filterParams[key] === '') && delete this.filterParams[key];
        });


        Object.keys(this.sortParams).forEach((key) => {
            return (this.sortParams[key] === null || this.sortParams[key] === 'none' || this.sortParams[key] === '') && delete this.sortParams[key];
        });


        if (Object.keys(this.filterParams).length > 0) {
            options.filter_by = this.filterParams;
        }


        if (Object.keys(this.sortParams).length > 0) {
            options.order_by = this.sortParams;
        }

        return this.model.$query(options).then((resource) => {

            this.pages = Math.ceil(resource.total_entries / options.per_page);
            this.entries = resource.total_entries;

            const object = resource.items ? Array.from(resource.items).map(result => new this.model(result)) : [];

            this.onDataLoaded(object);


        }, (err) => {
            this.onDataError(err);
        });
    }

    /**
     * @abstract
     * @param data
     */
    onDataLoaded(data) {
        throw `You must implement the onDataLoaded(data) method in ${this.constructor.name || 'the subclass'}`;
    }

    onPageChangeStarted() {

    }

    onDataError(err) {
    }

    hasNextPage() {
        return this.page < this.pages;
    }

    isLastPage() {
        return this.page === this.pages;
    }

    isFirstPage() {
        return this.page === 1;
    }

    hasPreviousPage() {
        return this.page > 1;
    }

    next() {
        if (this.hasNextPage() && !this.isLastPage()) {
            this.page = this.page + 1;
            this.changePage();
        }
    }

    prev() {
        if (this.hasPreviousPage() && !this.isFirstPage()) {
            this.page = this.page - 1;
            this.changePage();
        }
    }

    run() {
        this.changePage();
    }
}



// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/_helpers/PaginatedController.js